import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiChipOverrides = {
  defaultProps?: ComponentsProps['MuiTextField'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTextField'];
  variants?: ComponentsVariants['MuiTextField'];
}

function getMuiTextfieldOverride(): MuiChipOverrides {
  return {
    styleOverrides: {
      root: {
        borderRadius: "4px",

        fieldset: {
          borderColor: "var(--clr-grey-5)",
          borderWidth: "2px",
        },

        input: {
          padding: "12px",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 400,
          color: "var(--clr-grey-1)"
        }
      }
    },
  }
}

export default getMuiTextfieldOverride;